import { Component, OnInit } from '@angular/core';
import { ContactUsService } from '../../../section/user/service/contact-us.service';
import { SharedService } from '../../../component/shared/shared.service';
import { Subscription } from '../model/contact-us';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {

  userService : ContactUsService; 
  contacts: any = [];
  selectedObject:number = 0;
  constructor(private _sharedService: SharedService,private _UserService: ContactUsService) {
    _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString()  && text.Page === 'UNSUBSCRIBE') {
              this.delete();
          }  
      });
 
   }

  ngOnInit() {
    
    this.getSubscription();
  }
   
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
 
  getSubscription() : void {
     
     this._UserService.getSubscription().subscribe(data=>{
       
        this.contacts = data;
       
         
     },error=>{

     });
  }
  /*deleteSubscription(id: number) : void {
     
    this._UserService.deleteSubscription(id).subscribe(data=>{
      
      this.getSubscription();
      
        
    },error=>{

    });
 }*/
 delete() :void {
  this._UserService.deleteSubscription(this.selectedObject).subscribe(data=>{
    this.getSubscription();
  },error=>{

  });
}
deleteSubscription(id : number) :void {
this.selectedObject = id;
this._sharedService.emitDialog(true,"Delete",ActionMessage.UNSUBSCRIBE.toString(),true,DialogAction.DELETE.toString(),'UNSUBSCRIBE' );      
}
 
 

}



// WEBPACK FOOTER //
// ./src/app/section/user/subscription/subscription.component.ts